import {
  SourceType as ActionComposeSourceType,
  ActionType as ActionComposeActionType,
} from './actionCompose';
import getClient from './getClient';
// TODO: Check these (PLAYB-155 / WFA-110)

export type GetActionsResponse = {
  data: Action[];
};

// Double check with omnibar action type for overlap
// libs/api/src/lib/services/v1/actions.ts
export type Action = {
  id: number;
  summary: string;
  source: SourceType;
  who: Who;
  due_at: string;
  creator: Person;
  assignee: Person;
  body?: string;
  subject?: string;
  priority?: string;
  deleted_at?: string;
  completed_at?: string;
  failed?: boolean;
  type?: ActionType;
  smart_priority?: number;
  summary_v2?: string[];
  step_id?: number;
  flow_id?: number;
};

export type SourceType = ActionComposeSourceType;
export type ActionType = ActionComposeActionType | AdditionalActionTypes;
type AdditionalActionTypes =
  // overlap:
  //   | 'CALL'
  //   | 'GENERAL'
  //   | 'OTHER'
  | 'EMAIL'
  | 'IN_MAIL'
  | 'LINKEDIN_CONNECT'
  | 'SENDOSO'
  | 'SMS'
  // Are these still a thing?
  | 'IN_PERSON_VISIT'
  | 'DIRECT_MAIL'
  | 'WORKSPACE'
  | 'SALESFORCE';

// TODO: Check these (PLAYB-155)
export type Who = {
  id: number;
  name: string;
  company?: string;
  title?: string;
  tzid?: string;
  engagement_score?: number;
  sfdc_id: string;
};

export type Person = {
  id: number;
  name: string;
};

export type SearchParams = {
  page?: number;
  per_page?: number;
};

// TODO: fix this duplicate. Type should be import from the actions rewrite.
type TabName = 'Active' | 'Failed' | 'Executed Actions' | 'Assigned to Others';

export type OrderType = {
  field: string;
  direction: 'asc' | 'desc';
};

export type BodyParams = {
  page: number;
  per_page: number;
  tab: TabName;
  order?: OrderType;
};

export const getActions = (
  bodyParams?: Partial<BodyParams>,
): Promise<GetActionsResponse> =>
  getClient().post('actions', { json: bodyParams }).json();

type ActionCounts = {
  [tabName in TabName]: number;
};

type GetActionCountsResponse = {
  data: ActionCounts;
};

export const postActionCounts = (): Promise<GetActionCountsResponse> =>
  getClient().post('actions/tabs_count').json();
